export const wwc = {
    shortName: "wwc",
    name: "Women's World Cup"
}
